import { useState } from "react";
import { BellRing, Loader2, Smartphone } from "lucide-react";
import { toast } from "sonner";
import { Input } from "../ui/input";
import { api, apiError } from "../../lib/api";
import { useAuth } from "../../lib/auth";
import { enablePush, pushSupported, isIOS } from "../../lib/pwa";

const canPush = () => pushSupported() || isIOS();

/** El pasajero deja su email para que le avisemos cuando el tramo entre en promoción. */
export const PriceAlert = ({ o, d, testid }) => {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState(user?.email ?? "");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [phone, setPhone] = useState(canPush);
  const [pushed, setPushed] = useState(false);
  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    // el permiso de notificaciones se pide primero, mientras dura el toque del usuario
    let ok = false;
    if (phone) {
      try { ok = await enablePush({ route: `${o}|${d}` }); } catch (err) { toast.warning(err?.message || "No pudimos activar el aviso al celular"); }
    }
    setPushed(ok);
    try {
      const { data } = await api.post("/price-alerts", { email: email.trim(), origin: o, destination: d });
      setDone(true);
      toast.success(data?.already ? "Ya ten\u00edas esta alerta activa" : `Te avisamos a ${email.trim()}${ok ? " y a este celular" : ""} cuando haya promo`);
    } catch (err) { toast.error(apiError(err)); } finally { setBusy(false); }
  };
  if (done) return <p data-testid={`${testid}-done`} className="mt-3 flex items-center gap-2 text-sm font-semibold text-[var(--forest)]"><BellRing className="h-4 w-4" /> Listo: te avisamos por email{pushed ? " y al celular" : ""} cuando {o} → {d} tenga promo.</p>;
  if (!open) return (
    <button type="button" onClick={() => setOpen(true)} data-testid={`${testid}-open`} className="mt-3 inline-flex items-center gap-2 text-sm font-semibold text-[var(--forest)] underline-offset-4 hover:underline">
      <BellRing className="h-4 w-4" /> Avisame cuando este tramo tenga promo
    </button>
  );
  return (
    <form onSubmit={save} data-testid={`${testid}-form`} className="mt-3 flex flex-col gap-2">
      <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
        <Input data-testid={`${testid}-email`} type="email" required placeholder="Tu email" value={email} onChange={(e) => setEmail(e.target.value)} className="h-11 rounded-xl bg-white sm:max-w-xs" />
        <button disabled={busy} data-testid={`${testid}-submit`} className="flex h-11 items-center justify-center gap-2 rounded-xl bg-[var(--forest)] px-5 text-sm font-bold text-white disabled:opacity-60">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <BellRing className="h-4 w-4" />} Avisame
        </button>
      </div>
      {canPush() && (
        <label className="flex items-center gap-2 text-sm text-black/75">
          <input type="checkbox" data-testid={`${testid}-phone`} checked={phone} onChange={(e) => setPhone(e.target.checked)} className="h-4 w-4 accent-[var(--forest)]" />
          <Smartphone className="h-4 w-4" /> También avisame con una notificación en este celular
        </label>
      )}
    </form>
  );
};
